import SplitPayLearnMore from './SplitPayLearnMore';

export default SplitPayLearnMore;
